<template>
    <b-modal v-model="show" size="lg" title="КАТТА КИЧИКЛИГИ ТУЗАТИШ ПАРАМЕТРИ" class="cadastre-building"
             :no-close-on-esc="true" :no-close-on-backdrop="true">
        <div class="container-fluid">
            <div class="row">
                <div class="col-12">
                    <div class="form-group">
                        <label>Улуш коэффициент</label>
                        <numeric-input class="form-control"
                                       v-model="data.value"
                                       :precision="2"
                                       :class="{invalid: $v.data.value.$error}"
                        ></numeric-input>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn add-btn float-right" v-if="hasPermission('SETTINGS_BUILDING_CADASTRE_FIX_SIZE_ADD')" @click="save" :disabled="processing">
                Сақлаш
            </button>
            <button class="all-btn delete-btn float-right mr-2" @click="show=!show">
                Бекор қилиш
            </button>
        </div>
    </b-modal>
</template>

<script>
    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'
    import {required} from 'vuelidate/lib/validators';

    export default {
        name: "CadastreFixSizeEditModal",
        components: {
            'b-modal': bModal
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                processing: false,
                data: {}
            }
        },
        validations() {
            return {
                data: {
                    value: {
                        required
                    }
                }
            }
        },
        methods: {
            save() {
                this.$v.$touch()
                if (this.$v.$invalid) {
                    return;
                }
                const vm = this;

                this.$http.post(`cadastre/fix-size/save-value/${this.data.id}`, this.data)
                    .then(res => {
                        vm.processing = false;
                        const response = res.data;
                        if (response && response.status === 'SUCCESS') {
                            vm.show = false;
                            this.$eventBus.$emit('onCadastreFixSizeChanged', response);
                        }
                    }, err => {
                        vm.processing = false;
                        console.log(err);
                    });
            }
        },
        created() {
            this.$eventBus.$on('showCadastreFixSizeEditModal', (data) => {
                this.data = data;
                this.show = true;
            });
        }
    }
</script>

<style scoped>

</style>